import { Component, OnInit, Input, ElementRef, HostBinding, EventEmitter, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { map, flatMap, takeUntil } from 'rxjs/operators';

enum DivideResizerType
{
  Horizontal,
  Vertical
}

//component isn't finished, works fine for views which havs 1 chart on top
@Component({
  selector: 'divide-resizer',
  template: require('./divide-resizer.component.html'),
  styles: [require('./divide-resizer.component.css')]
})
export class DivideResizerComponent implements OnInit {

  @Input()
  public type = DivideResizerType.Horizontal

  @Input('enabled')
  public set enabled(value: boolean)
  {
    this._enabled = value;

    if(value)
    {
      this.position = this.position;
    }
    else
    {
       this.targetElements.forEach(e => this.disableElementResizing(e));
    }
     
  }

  public get enabled()
  {
    return this._enabled;
  }

  private _enabled = true;

  @Input()
  public initialPosition = 0.5;

  @Input()
  public initialDividePosition = 0.3;

  public get dividePosition()
  {
    return  this.elementsSet? this.position: this.initialDividePosition;
  }

  public elementsSet = false;

  public set position(value: number)
  {

    if(value<0.2)
    {
      value=0.2
    }
    if(value>0.8)  
    {
      value=0.8;
    }

  
    //setting style is faster than style binding
    let positionWithP = (value*100) + '%'; //1.023614451572073 - something is wrong fixing it visually
    if(this.type == DivideResizerType.Horizontal)
      this._host.nativeElement.style.top = positionWithP;
    else if(this.type == DivideResizerType.Vertical)
      this._host.nativeElement.style.left = positionWithP;

    let first = true;
    this.targetElements.forEach(e =>
    {
      if(first)
      {
        first = false;
        this.setElementSize(e, value);
        return;
      }
      
      this.setElementSize(e, 1.0-value);
    })
    this._position = value;
    this.elementsSet = true;
  }
  
  public get position()
  {
    return this._position;
  }

  private _position = 50;


  public get parentSize(): number
  {
    return this.getElementSize(this.parent);
  }

  public get parent(): any
  {
    return this._host.nativeElement.parentElement;
  }

  public get targetElements()
  {
    return Array.from(this.parent.children).filter(c => (c as any).tagName != this._host.nativeElement.tagName);
  }

  //host bindings
  @HostBinding('style.height.px') //TODO: vertical mode
  @Input()
  public thickness = 6;

  @HostBinding('style.display')
  public get display()
  {
    return this.enabled? 'block': 'none';
  }
  

  @HostBinding('class.vertical')
  public get vertical()
  {
    return this.type == DivideResizerType.Vertical;
  }

  @HostBinding('class.horizontal')
  public get horizontal()
  {
    return this.type == DivideResizerType.Horizontal;
  }

  mouseup = new EventEmitter<MouseEvent>();
  mousedown = new EventEmitter<MouseEvent>();
  mousemove = new EventEmitter<MouseEvent>();

  mousedrag!: Observable<{top: number, left: number}>;

  //host listeners
  @HostListener('document:mouseup', ['$event'])
  onMouseup(event: MouseEvent) 
  {
      this.mouseup.emit(event);
  }

  @HostListener('mousedown', ['$event'])
  onMousedown(event: MouseEvent) 
  {
      this.mousedown.emit(event);
      return false; // Call preventDefault() on the event
  }

  @HostListener('document:mousemove', ['$event'])
  onMousemove(event: MouseEvent) 
  {
    if(!this.stopEmit)
    {
      this.mousemove.emit(event);
    }
      
  }

  constructor(private _host: ElementRef) 
  {
    this.mousedrag = this.mousedown.pipe(map(event => {
      return {
          top: event.clientY - this._host.nativeElement.offsetTop,
          left: event.clientX - this._host.nativeElement.offsetLeft,
      };
    }))
    .pipe(flatMap(elementOffset => this.mousemove.pipe(map(pos => ({
            top: pos.clientY - elementOffset.top,
            left: pos.clientX - elementOffset.left
    })))
    .pipe(takeUntil(this.mouseup))));
  }

  ngOnInit() 
  {
    this.position = this.initialPosition;
    this.mousedrag.subscribe(
    {
      next: pos => 
      {
          if(!this.enabled)
            return;

          if(this.type == DivideResizerType.Horizontal)
          {
            this.position = ((pos.top-(this.thickness/2))/this.parentSize)
          }
          else if(this.type == DivideResizerType.Vertical)
          {
            this.position = ((pos.left-(this.thickness/2))/this.parentSize)
          }
      }
    });
  }

  private getElementSize(element:any) : number
  {
    if(this.type == DivideResizerType.Horizontal)
    {
      return element.offsetHeight;
    }

    return element.offsetWidth;
  }

  private stopEmit = false;
  private setElementSize(element: any, size: number)
  {
  

    if(!this.enabled)
      return;

    let property = 'width';
    if(this.type == DivideResizerType.Horizontal)
    {
      property = 'height';
    }

    const drStyle = property+': '+ (size*100).toFixed(4) +'% !important';



    element.style.cssText += drStyle;
    element.dataset.drStyle = drStyle;
  }

  

  private disableElementResizing(element: any)
  {
    element.style="";
  }

}
